export default {
  open: "OFFER_STATUS_OPEN",
  accepted: "OFFER_STATUS_ACCEPTED",
  declined: "OFFER_STATUS_DECLINED",
  invalidated: "OFFER_STATUS_INVALIDATED",
  done: "OFFER_STATUS_DONE"
};
